import { useEffect } from "react";
import { X } from "lucide-react";
import FilterSidebar from "./FilterSidebar";
import Button from "../loadout/Button";

// Bottom-sheet on mobile.  Slides up via CSS translate — no motion library.
export default function MobileFilterSheet({
  open,
  onClose,
  taxonomy,
  facets,
  active,
  onToggleValue,
  onSetPrice,
  visibleCount,
  onClear,
}) {
  useEffect(() => {
    if (!open) return;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <div
      aria-hidden={!open}
      className={
        "fixed inset-0 z-50 lg:hidden pointer-events-" + (open ? "auto" : "none")
      }
    >
      {/* Scrim */}
      <div
        onClick={onClose}
        className={
          "absolute inset-0 bg-black/60 transition-opacity duration-200 " +
          (open ? "opacity-100" : "opacity-0")
        }
      />
      {/* Sheet */}
      <div
        className={
          "absolute left-0 right-0 bottom-0 h-[85vh] bg-[#0A0A0A] border-t border-[#1F1F1F] " +
          "flex flex-col transition-transform duration-200 " +
          (open ? "translate-y-0" : "translate-y-full")
        }
      >
        <div className="flex items-center justify-between px-4 py-3 border-b border-[#1F1F1F]">
          <span className="font-mono text-[12px] uppercase tracking-[0.08em] text-white">
            FILTERS
          </span>
          <button type="button" onClick={onClose} aria-label="Close">
            <X className="h-5 w-5 text-white" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-4">
          <FilterSidebar
            taxonomy={taxonomy}
            facets={facets}
            active={active}
            onToggleValue={onToggleValue}
            onSetPrice={onSetPrice}
            className="w-full border-r-0 pr-0"
          />
        </div>
        <div className="border-t border-[#1F1F1F] p-4 flex items-center gap-3">
          <button
            type="button"
            onClick={onClear}
            className="font-sans text-[12px] uppercase tracking-[0.04em] text-white/80 hover:text-[#FF9F1C] underline underline-offset-4"
          >
            Clear all
          </button>
          <Button variant="primary" className="flex-1 h-12" onClick={onClose}>
            Apply (showing {visibleCount} results)
          </Button>
        </div>
      </div>
    </div>
  );
}
